export default __webpack_public_path__ + "static/media/icon-search.b0fd0c9c.svg";